import '../../style.css'
import React, { useState, useEffect } from 'react'
import OutputTable from '../dataOutput/outputTable.js'
import BlupsTable from './blupsTable.js';
import BlupsMeansDataTable from './blupsMeansDataTable.js';
import ClipLoader from "react-spinners/ClipLoader";
import { runBlupsAnalysis } from '../../services/api.js'
import BlupsMeansDataVisualizations from './blupsMeansDataVisualizations.js';
import { notification } from 'antd';

function BlupsAnalysisResultsPanel({ data }) {
    const [tabOptions, setTabOptions] = useState([
        { key: 0, label: 'Means Data', value: 'Means Data' },
        { key: 1, label: 'Visualizations', value: 'Visualizations' }
    ]);
    const [activeTab, setActiveTab] = useState('Means Data');
    const [filteredData, setFilteredData] = useState({});
    const [filteredDataHeaders, setFilteredDataHeaders] = useState({});
    const [loadingBlups, setLoadingBlups] = useState(false);
    const [blupsRecords, setBlupsRecords] = useState([]);
    const [blupsOutputHeaders, setBlupsOutputHeaders] = useState([]);
    const onTabClicks = async (e) => {
        setActiveTab(e.target.name)
    }

    const [notificationApi, contextHolder] = notification.useNotification({
        maxCount: 1
    });

    useEffect(() => {
        setTabOptions([
            { key: 0, label: 'Means Data', value: 'Means Data' },
            { key: 1, label: 'Visualizations', value: 'Visualizations' }
        ]);
        setActiveTab('Means Data');
    }, [data])

    const createFilteredOutput = (varieties, traits) => {
        let output = [];
        let temp = [];
        if (varieties.length > 0) {
            blupsRecords.forEach(record => {
                varieties.forEach(line => {
                    if (record.NAME === line) {
                        temp.push(record);
                    }
                })
            })
        }
        else {
            temp = blupsRecords;
        }
        if (traits.length > 0) {
            temp.forEach(record => {
                const outputRecord = { NAME: record.NAME }
                traits.forEach(trait => {
                    outputRecord[trait] = record[trait];
                })
                output.push(outputRecord);
            })
        }
        else {
            output = temp;
        }
        const filteredDataLength = Object.keys(filteredData).length + 1;
        filteredData['Filter' + (filteredDataLength)] = output
        setFilteredData({ ...filteredData });
        filteredDataHeaders['Filter' + (filteredDataLength)] = Object.keys(output[0]);
        setFilteredDataHeaders({ ...filteredDataHeaders });
        const newTabOptions = [
            { key: 0, label: 'Means Data', value: 'Means Data' },
            { key: 1, label: 'Visualizations', value: 'Visualizations' },
            { key: 2, label: 'BLUPs', value: 'BLUPs' },
        ]
        for (let i = 0; i < filteredDataLength; i++) {
            newTabOptions.push({ key: Object.keys(newTabOptions).length, label: `Filter${i + 1}`, value: `Filter${i + 1}`, index: i });
        }
        setActiveTab(`Filter${filteredDataLength}`);
        setTabOptions(newTabOptions);
    }

    const runBlups = async () => {
        notificationApi.destroy()
        if (data.years.length <= 1) {
            notificationApi.warning({
                message: 'Cannot Run BLUPs Analysis',
                description: 'To run BLUPs analysis, you must use data from at least 2 different years. Please modify your means data query and try again.',
                duration: 5,
                placement: 'top',
            });
        }
        else {
            setLoadingBlups(true);
            setFilteredData({});
            setFilteredDataHeaders({});
            const newTabOptions = [
                { key: 0, label: 'Means Data', value: 'Means Data' },
                { key: 1, label: 'Visualizations', value: 'Visualizations' },
                { key: 2, label: 'BLUPs', value: 'BLUPs' },
            ];
            setTabOptions(newTabOptions);
            setActiveTab('BLUPs');
            try {
                const response = await runBlupsAnalysis(data.traits, data.data);
                if (response.status === 200) {
                    setBlupsRecords(response.data.BLUPs);
                    setBlupsOutputHeaders(Object.keys(response.data.BLUPs[0]))
                    if (response.data.traits_fail.length > 0) {
                        const failedTraits = response.data.traits_fail.join(', ')
                        notificationApi.info({
                            message: 'BLUPs Analysis Failed for Some Traits',
                            description: `BLUPs analysis failed for the following traits:\n${failedTraits}`,
                            duration: 0,
                            placement: 'top',
                        });
                    }
                }
                else {
                    notificationApi.error({
                        message: 'BLUPs Analysis failed',
                        description: 'An unexpected error occurred.',
                        duration: 0,
                        placement: 'top',
                    })
                }
            }
            catch (err) {
                notificationApi.error({
                    message: 'BLUPs Analysis failed',
                    description: 'An unexpected error occurred.',
                    duration: 0,
                    placement: 'top',
                })
            }
            setLoadingBlups(false);
        }
    }

    return (
        <>
            {contextHolder}
            <div className="row">
                <div className="my-3 p-3 bg-body rounded shadow">
                    <div className="row">
                        <h5>Results</h5>
                        <br />
                        <br />
                    </div>
                    <div className="card flex">
                        <div className="card-header">
                            <ul className="nav nav-tabs card-header-tabs" data-bs-tabs="tabs">
                                {tabOptions.map((tab) => {
                                    return (
                                        <li key={tab.key} className={`nav-item ${activeTab === tab.value ? 'active' : ''}`}>
                                            <button name={tab.value} className={`nav-link ${activeTab === tab.value ? 'active' : ''}`} onClick={onTabClicks} disabled={loadingBlups}>
                                                {tab.label}
                                            </button>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                        {
                            (loadingBlups &&
                                <div className="d-flex justify-content-center my-5">
                                    <ClipLoader
                                        color={"#38724f"}
                                        loading={loadingBlups}
                                        size={100}
                                        aria-label="Loading Spinner"
                                        data-testid="loader"
                                    />
                                </div>
                            ) ||
                            (activeTab === 'Means Data' &&
                                <BlupsMeansDataTable
                                    data={data.data}
                                    runBlups={runBlups} />
                            ) ||
                            (activeTab === 'Visualizations' &&
                                <BlupsMeansDataVisualizations
                                    data={data.data}
                                    traits={data.traits}
                                    traitAverageData={data.traitAverage}
                                    countByYearData={data.countByYear}
                                    countByLocYearData={data.countByLocYear}
                                    years={data.years}
                                ></BlupsMeansDataVisualizations>
                            ) ||
                            (activeTab === 'BLUPs' &&
                                <div>
                                    <BlupsTable data={blupsRecords} columns={blupsOutputHeaders}
                                        functions={{ createFilteredOutput }} />
                                </div>
                            ) ||
                            (activeTab.includes('Filter') &&
                                <div>
                                    <OutputTable data={filteredData[activeTab]} columns={filteredDataHeaders[activeTab]} />
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default BlupsAnalysisResultsPanel;